import { Component, Input } from '@angular/core';

export type AvatarSize = 'small' | 'medium' | 'large';
export type AvatarShape = 'circle' | 'square';
export type AvatarStatus = 'online' | 'offline' | 'away' | 'none';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input() imageUrl: string = '';
  @Input() initials: string = '';
  @Input() name: string = '';
  @Input() size: AvatarSize = 'medium';
  @Input() shape: AvatarShape = 'circle';
  @Input() status: AvatarStatus = 'none';
  @Input() bordered: boolean = false;
  @Input() fallbackIcon: string = 'assets/images/user_icon_black.png';

  imageLoadFailed: boolean = false;

  get displayInitials(): string {
    if (this.initials) return this.initials.toUpperCase();
    if (this.name) {
      const parts = this.name.trim().split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      }
      return parts[0].substring(0, 2).toUpperCase();
    }
    return '';
  }

  get shouldShowImage(): boolean {
    return !!this.imageUrl && !this.imageLoadFailed;
  }

  get shouldShowInitials(): boolean {
    return (this.imageLoadFailed || !this.imageUrl) && !!this.displayInitials;
  }

  get shouldShowFallback(): boolean {
    return (this.imageLoadFailed || !this.imageUrl) && !this.displayInitials;
  }

  onImageError(): void {
    this.imageLoadFailed = true;
  }

  get avatarClasses(): string {
    const classes = ['avatar', `avatar-${this.size}`, `avatar-${this.shape}`];
    if (this.bordered) classes.push('avatar-bordered');
    if (this.status !== 'none') classes.push(`avatar-status-${this.status}`);
    return classes.join(' ');
  }
}
